export default __webpack_public_path__ + "img/input-clear.58d75ae77635087c77e9e3cf14cd42a7.svg";